import { BELGE_GRUBU_VE_TURU_BASVURU_SAYILARI } from "../constants/requestUrls";
import { postRequest } from "../request";

const belgeGrubuVeTuruBasvuruSayilari = (BelgeGrubuId) => 
{
    let filterModel= {};
    filterModel.BelgeGrubuId=BelgeGrubuId;
    const data = JSON.stringify(filterModel);
    return postRequest({url:BELGE_GRUBU_VE_TURU_BASVURU_SAYILARI,data});
}

export default belgeGrubuVeTuruBasvuruSayilari;